import _default from './Header';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/elements/Header/index.js
// module id = 652
// module chunks = 0